import { createDrawer, createDrawerTrigger } from "ds/components/DrawerNew/utils";
import { Space } from "types/generated";

import { SpacesDrawerWriteMode, SpacesLayoutMode } from "../types";
import SpaceDrawerBuilder from "./Builder";
import SpaceDrawerView from "./View";

type SpaceDrawerProps = {
  drawerWriteMode?: SpacesDrawerWriteMode;
  space?: Space;
  layoutMode?: SpacesLayoutMode;
  onClose: () => void;
  isRootAdmin: boolean;
  hideNotEditableBanner?: boolean;
  registerBeforeSpaceNavigate?: (fn: () => boolean | Promise<boolean>) => () => void;
};

const SpaceDrawer = createDrawer(
  ({
    drawerWriteMode,
    space,
    layoutMode,
    onClose,
    isRootAdmin,
    hideNotEditableBanner,
    registerBeforeSpaceNavigate,
  }: SpaceDrawerProps) => {
    return drawerWriteMode ? (
      <SpaceDrawerBuilder
        drawerWriteMode={drawerWriteMode}
        space={space}
        layoutMode={layoutMode}
        onClose={onClose}
        isRootAdmin={isRootAdmin}
        registerBeforeSpaceNavigate={registerBeforeSpaceNavigate}
      />
    ) : (
      <SpaceDrawerView
        space={space}
        isRootAdmin={isRootAdmin}
        onClose={onClose}
        hideNotEditableBanner={hideNotEditableBanner}
      />
    );
  }
);

export const showSpaceDrawer = createDrawerTrigger(SpaceDrawer);
